import { Component, Input, OnInit } from "@angular/core";
import { NavController } from "ionic-angular";

@Component({
  selector: "close-button",
  templateUrl: "close-button.html",
})
export class CloseButtonComponent implements OnInit {
  @Input() patientId: string = null;
  @Input() type: string = null;
  redirectPage: string;

  constructor(public navCtrl: NavController) {}

  ngOnInit() {
    this.setRedirectPage();
  }

  setRedirectPage() {
    this.redirectPage = `/#/reports/${this.patientId}/${this.type}/report-list`;
  }

  closeReportDetail() {
    this.navCtrl.pop();
    //window.location.href = this.redirectPage;
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/components/close-button/close-button.ts